import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cookieName: String,
    dismissedKey: String,
  };

  connect() {
    // Show banner to all users during rebrand period, unless they've dismissed it
    if (!this.isBannerDismissed()) {
      this.showBanner();
    }

    // Smart dismissal: If user is on the rebrand announcement page,
    // they're now aware of the rebrand, so dismiss the banner
    if (this.isOnRebrandPage()) {
      this.markAsAware();
    }
  }

  dismiss() {
    // Hide the banner
    this.element.classList.add("hidden");

    // Mark as dismissed in localStorage
    this.markAsAware();
  }

  markAsAware() {
    // Mark user as aware of rebrand (same as dismissing)
    localStorage.setItem(this.dismissedKeyValue, "true");
  }

  isOnRebrandPage() {
    // Check if current page is the rebrand announcement page
    return window.location.pathname === "/rebrand-announcement";
  }

  hasRedirectCookie() {
    // Check if the redirect cookie exists
    return (
      document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${this.cookieNameValue}=`)) !== undefined
    );
  }

  isBannerDismissed() {
    // Check if user has already dismissed the banner or is aware of rebrand
    return localStorage.getItem(this.dismissedKeyValue) === "true";
  }

  showBanner() {
    // Show the banner by removing the hidden class
    this.element.classList.remove("hidden");
  }
}
